import React, { useEffect, useState } from 'react'
import './WidgetFrame.scss'

interface WidgetFrameProps {
  title: string
  badge?: number
  loading?: boolean
  children: React.ReactNode
  headerButtons?: React.ReactNode
  dragHandleProps?: any
}

export const WidgetFrame: React.FC<WidgetFrameProps> = ({ title, badge, loading = false, children, headerButtons, dragHandleProps }) => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true)
    }, 100)
    return () => clearTimeout(timer)
  }, [])

  return (
    <div className={`widget-frame fade ${show ? 'show' : ''}`}>
      <div className="widget-frame__header">
        <div className="widget-frame__header-content">
          <div className="widget-frame__title-section">
            {dragHandleProps && (
              <div className="widget-frame__drag-handle" {...dragHandleProps}>
                <i className="bi bi-grip-vertical"></i>
              </div>
            )}
            <div className="widget-frame__title-wrapper">
              <h6 className="widget-frame__title">{title}</h6>
              {badge !== undefined && badge !== null && <span className="widget-frame__badge">{badge}</span>}
            </div>
          </div>
          <div className="widget-frame__header-actions">
            {loading && (
              <div className="widget-frame__spinner">
                <div className="widget-frame__spinner-dot"></div>
                <div className="widget-frame__spinner-dot"></div>
                <div className="widget-frame__spinner-dot"></div>
              </div>
            )}
            {headerButtons}
          </div>
        </div>
      </div>
      <div className="widget-frame__body">{children}</div>
    </div>
  )
}
